export const truncateForLength = function(text, untilLength) {
  return ( text ? text.length > untilLength + 2 : false ) 
    ? text.substr(0, untilLength-1) + '..' : text;
}